/** A referential list of statuses: no tenant, no parameter. */
class FetchUserStatuses {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchUserStatuses;
